import {ScrollTrigger} from "gsap/ScrollTrigger";

export class Count {
    private start: number;
    private parts: string[];
    private newParts: string[];
    private trigger: ScrollTrigger;

    constructor(private element: HTMLElement, private duration: number = 1000) {
        this.animateProgress = this.animateProgress.bind(this);
        this.init();
    }

    init() {
        const string = this.element.innerHTML;
        this.parts = string.split(/(\d+(\.\d+)?)/g).filter(x => x !== undefined && x !== '');
        this.newParts = [...this.parts];

        this.trigger = new ScrollTrigger({
            trigger: this.element,
            start: "top bottom",
            end: "center top",
            toggleActions: "play none none none",
            onEnter: () => {
                this.start = performance.now();
                requestAnimationFrame(this.animateProgress);
            },
        });
    }

    private animateProgress() {
        const now = performance.now();
        const elapsed = now - this.start;
        const progress = Math.min(elapsed / this.duration, 1);

        this.parts.forEach((p, i) => {
            const number = parseFloat(this.parts[i]);

            if (!isNaN(number)) {
                const value = Math.round(number * progress).toString();
                this.newParts[i] = value.toString();
            }
        });

        const updatedHTML = this.newParts.join('');
        if (this.element.innerHTML !== updatedHTML) {
            this.element.innerHTML = updatedHTML;
        }

        if (progress < 1) {
            requestAnimationFrame(this.animateProgress);
        } else {
            this.trigger.kill();
        }
    }
}



